/* eslint-disable no-alert */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import Loading from '../../components/common/loading'
import MenuList from './components/MenuList'
import CategorySection from './components/CategorySection'

import MenuActions from '../../reducers/menuReducer'

class CategoryContainer extends Component {
  state = {
    saving: false,
    hasChanged: false,
    selected: [],
    oldSelected: [],
  }

  componentDidMount() {
    const { fetchMenus, fetchSelectedCategories } = this.props

    fetchMenus()
    fetchSelectedCategories()
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCategories } = this.props

    if (selectedCategories !== nextProps.selectedCategories) {
      this.setState({
        selected: Object.keys(nextProps.selectedCategories),
        oldSelected: Object.keys(nextProps.selectedCategories),
        hasChanged: false,
      })
    }
  }

  onCategoryChange = categoryKey => {
    const { selected } = this.state
    let newArr = []

    if (_.includes(selected, categoryKey)) {
      newArr = _.filter(selected, value => value !== categoryKey)
    } else {
      newArr = [...selected, categoryKey]
    }

    this.setState({ selected: newArr, hasChanged: true })
  }

  render() {
    const { loading } = this.props

    return (
      <div>
        <Loading active={loading} />
        <MenuList
          {...this.props}
          {...this.state}
          onChange={this.onCategoryChange}
          setSaving={val => this.setState({ saving: val })}
        />
        <CategorySection {...this.props} {...this.state} />
      </div>
    )
  }
}

const mapStateToProps = ({ menus }) => ({
  menus: menus.data,
  loading: menus.loading || menus.selectedCategoriesLoading,
  selectedCategories: menus.selectedCategories,
  categoriesData: _.reduce(
    menus.data,
    (result, eachMenu) => {
      _.map(eachMenu.categories, (category, key) => {
        // eslint-disable-next-line no-param-reassign
        result[key] = category.name
      })

      return result
    },
    {}
  ),
})

const mapDispatchToProps = {
  fetchMenus: MenuActions.fetchMenusRequest,
  fetchSelectedCategories: MenuActions.fetchSelectedCategoriesRequest,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryContainer)



// WEBPACK FOOTER //
// ./src/containers/category/index.js